/**
 * Simple i18n utility for ArchaeoHub
 */

export const translations = {
  tr: {
    // General
    'app.title': 'ArchaeoHub',
    'app.loading': 'Yükleniyor...',
    'app.error': 'Hata',
    'app.save': 'Kaydet',
    'app.cancel': 'İptal',
    'app.delete': 'Sil',
    'app.edit': 'Düzenle',
    'app.close': 'Kapat',
    'app.search': 'Ara...',
    'app.date': 'Tarih',
    'app.time': 'Saat',
    
    // Navigation
    'nav.dashboard': 'Panel',
    'nav.assets': 'Eserler',
    'nav.reconstruct': 'Parça Birleştirme',
    'nav.logout': 'Çıkış Yap',
    'nav.register': 'Kayıt Ol',

    // Login View
    'login.title': 'Hoş Geldiniz',
    'login.subtitle': 'ArchaeoHub ile kazılarınızı yönetin',
    'login.email': 'E-posta Adresi',
    'login.password': 'Şifre',
    'login.button': 'Giriş Yap',
    'login.error': 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.',
    'login.name': 'Ad Soyad',
    'login.passwordHint': 'En az 6 karakter',
    'login.confirmPassword': 'Şifre Tekrar',
    'login.register': 'Hesap Oluştur',

    // Dashboard View
    'dashboard.title': 'Aktif Kazı Alanları',
    'dashboard.addSite': 'Yeni Kazı Alanı Ekle',
    'dashboard.deleteConfirm': 'Bu kazı alanını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
    'dashboard.noSites': 'Henüz kazı alanı bulunmuyor.',
    'dashboard.createSite': 'Kazı Alanı Oluştur',
    'dashboard.siteName': 'Kazı Alanı Adı',
    'dashboard.siteDesc': 'Açıklama',
    'dashboard.siteLocation': 'Konum',
    'dashboard.siteDirector': 'Kazı Başkanı',
    'dashboard.sitePeriod': 'Dönem',
    'dashboard.siteStatus': 'Durum',
    'dashboard.statusActive': 'Aktif',
    'dashboard.statusPaused': 'Beklemede',
    'dashboard.statusCompleted': 'Tamamlandı',
    
    // Site Detail View
    'site.tabDetails': 'Detaylar',
    'site.tabAssets': 'Kütüphane',
    'site.tabLogbook': 'Kayıt Defteri',
    'site.tabReconstruct': 'Montaj',
    'site.edit': 'Alanı Düzenle',
    'site.director': 'Kazı Başkanı',
    'site.period': 'Dönem',
    'site.location': 'Konum',
    'site.status': 'Durum',
    'site.members': 'Yetkili Üyeler',
    'site.membersLabel': 'Erişimi Olan Üyeler (E-posta)',
    'site.addMember': 'Üye Ekle',
    'site.enterEmail': 'Üye E-posta adresi...',
    'site.recentActivity': 'Son Aktiviteler',
    'site.noActivity': 'Henüz aktivite yok. Günlük girişi ekleyerek veya 3D varlık yükleyerek başlayın.',
    'site.analyses': 'Analizler',
    'site.analysesSub': 'Alan istatistikleri & raporlar',
    'site.comingSoon': 'Yakında',
    
    // Assets View
    'assets.title': 'Kütüphane',
    'assets.upload': 'Yeni Eser/Model Yükle',
    'assets.createFolder': 'Klasör Oluştur',
    'assets.guide': '3DF Zephyr Rehberi',
    'assets.empty': 'Bu klasör boş.',
    'assets.dragDrop': 'Dosyaları buraya sürükleyin veya',
    'assets.browse': 'bilgisayardan seçin',
    'assets.supported': 'Desteklenen formatlar: OBJ, STL, PLY, GLB ve Görseller (JPG, PNG). Klasör yapınızı sürükleyip bırakabilirsiniz.',
    'assets.takePhoto': 'Fotoğraf Çek',
    'assets.uploading': 'Yükleniyor...',
    'assets.folderName': 'Klasör Adı',
    'assets.viewerTitle': '3D Görüntüleyici',
    'assets.pdfBtn': '📄 Montaj Şemasını Görüntüle',
    'assets.rotation': '⟲ Döndür',
    'assets.resetView': 'Görünümü Sıfırla',
    'assets.moveAsset': 'Varlığı Taşı',
    'assets.targetFolder': 'Hedef Klasör',
    'assets.rootDir': '(Ana Dizin)',
    'assets.move': 'Taşı',
    'assets.folderCount': 'klasör',
    'assets.fileCount': 'dosya',

    // Logbook View
    'logbook.title': 'Kayıt Defteri & Envanter',
    'logbook.addEntry': 'Yeni Kayıt Ekle',
    'logbook.empty': 'Henüz hiçbir kayıt bulunmuyor.',
    'logbook.type': 'Kayıt Tipi',
    'logbook.typeFind': 'Eser Buluntusu',
    'logbook.typeTrench': 'Açma Günlüğü',
    'logbook.typeNote': 'Genel Not',
    'logbook.entryTitle': 'Başlık',
    'logbook.content': 'İçerik',
    'logbook.images': 'Görseller',
    'logbook.tags': 'Etiketler (Virgülle ayırın)',
    'logbook.artifactID': 'Eser ID',
    'logbook.material': 'Materyal',
    'logbook.dimensions': 'Boyutlar',
    'logbook.location': 'Buluntu Yeri',
    
    // Reconstruct View
    'recon.title': 'Montaj Masası',
    'recon.subtitle': '3D parçaları sürükleyip bırakarak birleştirin',
    'recon.selectParts': '1. Kütüphaneden Parça Seçin',
    'recon.library': 'Kütüphane',
    'recon.emptyLib': 'Kütüphanede 3D model bulunmuyor.',
    'recon.addToDesk': 'Masaya Ekle',
    'recon.desk': '2. Çalışma Masası',
    'recon.emptyDesk': 'Masada parça yok. Kütüphaneden parça ekleyin.',
    'recon.clearDesk': 'Masayı Temizle',
    'recon.preview': 'Önizleme (Birleştir)',
    'recon.downloadPDF': '📄 Montaj Şeması İndir',
    'recon.saveToLib': '💾 Kütüphaneye Ekle',
    'recon.controls': 'Kontroller: Sol tık + Sürükle = Döndür | Sağ tık + Sürükle = Kaydır | Scroll = Yakınlaş',
    'recon.loading1': 'Dosyalar yükleme için hazırlanıyor...',
    'recon.loading2': 'Veriler birleştirme sunucusuna gönderiliyor...',
    'recon.loading3': 'Geometri işleniyor (bu işlem biraz sürebilir)...',
    'recon.loading4': 'Sonuç yükleniyor...',
    'recon.done': 'Birleştirme Tamamlandı!',
    'recon.download': 'Modeli İndir',
    'recon.processingTitle': 'İşleniyor...',
    'recon.processingDesc': 'Geometri ve doku desenleri analiz ediliyor',
    'recon.packagingLib': 'Paketleniyor (Model + PDF)...',
    'recon.uploadingModel': 'Yükleniyor (Model)...',
    'recon.capturingPhotos': 'Fotoğraflar kaydediliyor...',
    'recon.uploadingPDF': 'Yükleniyor (PDF)...',
    'recon.addedToLib': 'Kütüphaneye Eklendi',
    'recon.added': '✅ Eklendi',
    'recon.mobileWarning': 'Montaj masası mobil cihazlarda tam performanslı çalışmayabilir. En iyi deneyim için masaüstü sürümünü kullanmanızı öneririz.',
    'recon.tryAnyway': 'Yine de dene',
    'recon.photogrammetryTitle': '3D Model Oluşturma',
    'recon.photogrammetryConfirm': '"{name}" klasöründeki {count} fotoğraf kullanılarak 3D model oluşturulacaktır. İşlem ücreti: {credits} kredi.',
    'recon.photogrammetryDesc': 'Bu işlem bulut sunucularımız üzerinde otomatik olarak gerçekleştirilecektir. İşlem başladığında krediniz düşülecek ve tamamlandığında kütüphanenize bir .glb veya .obj dosyası eklenecektir.',
    'recon.photogrammetryQueued': '3D model oluşturma işi sıraya alındı. İşlem bitince size haber vereceğiz.',
    'recon.photogrammetryNoPhotos': 'Klasörde desteklenen formatta fotoğraf bulunamadı.',
    'recon.photogrammetryMinPhotos': 'Bu işlem için en az 10 fotoğraf gereklidir.',

    // Credits
    'credits.creditLabel': 'Kredi',
    'credits.balance': 'Kredi Bakiyesi',
    'credits.currentBalance': 'Mevcut Bakiye',
    'credits.buy': 'Kredi Satın Al',
    'credits.assemblyPrice': 'Her montaj 1 kredi ($1) tutar.',
    'credits.webNotice': 'Kredi satın almak için ArchaeoHub mobil uygulamasını kullanın.',
    'credits.purchaseSuccess': 'Kredi başarıyla eklendi',
    'credits.purchaseFailed': 'Satın alma başarısız',
    'credits.purchaseCancelled': 'Satın alma iptal edildi',
    'credits.insufficient': 'Yetersiz kredi. Montaj için en az 1 krediniz olmalıdır.',
    'credits.history': 'Geçmiş İşlemler',
    'credits.noHistory': 'Henüz işlem bulunmuyor.',

    // Landing Page
    'landing.heroTag': '🏺 Dijital Arkeoloji Platformu',
    'landing.heroTitle': 'Kazı Yönetiminin Modern Yolu',
    'landing.heroSub': 'ArchaeoHub; kazı alanlarını, 3D eser taramalarını, dijital günlükleri ve akıllı parça birleştirmeyi tek bir platformda toplar.',
    'landing.startFree': '🚀 Ücretsiz Başla',
    'landing.explore': 'Özellikleri Keşfet',
    'landing.stats3D': '3D Eser Tarama',
    'landing.statsAI': 'AI Parça Birleştirme',
    'landing.statsLang': '2 Dil Desteği',
    'landing.statsSites': '∞ Kazı Alanı & Ekip',
    'landing.featuresTitle': 'Ekibinizin İhtiyaç Duyduğu Her Şey',
    'landing.featuresSub': 'Sahadan laboratuvara — ArchaeoHub tüm arkeolojik iş akışını kapsar.',
    'landing.workflowTitle': 'Kazıdan Belgelemeye',
    'landing.workflowSub': 'Arkeolojik iş akışınıza doğal olarak uyan basit dört adımlı süreç.',
    'landing.pricingTitle': 'Kullandıkça Öde',
    'landing.pricingSub': 'ArchaeoHub\'ı kullanmak ücretsizdir. Sadece AI parça birleştirme işlemi için ödeme yaparsınız.',
    'landing.pricingNote': 'Krediler Android uygulamasında <strong>Google Play</strong> üzerinden güvenle satın alınır. Kredilerin süresi asla dolmaz. Diğer tüm özellikler tamamen <strong>ücretsizdir</strong>.',
    'landing.pricingUserNote': '1 kredi = 1 USD (Fiyat konuma göre değişebilir ve vergiler dahil değildir)',
    'landing.ctaTitle': 'Kazılarınızı Belgelemeye Bugün Başlayın',
    'landing.ctaSub': 'Kaydolmak ücretsizdir. Kredi kartı gerekmez. Masaüstü ve mobil uyumludur.',
    'landing.footerCopy': '© 2026 ArchaeoHub. Tüm hakları saklıdır.',
    'landing.privacy': 'Gizlilik Politikası',
    'landing.contactEmail': 'gulerege.tr@gmail.com',
    'landing.feature1Title': 'Yönetimi',
    'landing.feature1Desc': 'Ekip tabanlı izinlerle sınırsız kazı alanı oluşturun ve yönetin.',
    'landing.feature2Desc': '3D taramaları yükleyin ve görüntüleyin. Eserleri klasörler halinde kolayca düzenleyin.',
    'landing.feature3Desc': 'Otomatik montaj sunucumuzu kullanarak parçaları akıllıca birleştirin.',
    'landing.feature4Title': 'PDF Rehberler',
    'landing.feature4Desc': 'Her birleştirme için otomatik olarak iki dilli montaj şemaları oluşturun.',

    // Account Deletion
    'deleteAccount.title': 'Hesabı Sil',
    'deleteAccount.warning': 'DİKKAT: Bu işlem geri alınamaz.',
    'deleteAccount.explanation': 'Hesabınızı sildiğinizde; oluşturduğunuz tüm kazı alanları, yüklediğiniz 3D modeller, dijital günlükler ve mevcut kredileriniz kalıcı olarak silinecektir.',
    'deleteAccount.confirmLabel': 'Onaylamak için "SİL" yazın:',
    'deleteAccount.button': 'Hesabımı Kalıcı Olarak Sil',
    'deleteAccount.reauthRequired': 'Güvenlik nedeniyle bu işlemi gerçekleştirmek için tekrar giriş yapmanız gerekiyor.',
    'deleteAccount.success': 'Hesabınız ve tüm verileriniz başarıyla silindi.',
    'deleteAccount.error': 'Hesap silme sırasında bir hata oluştu.',
    'deleteAccount.deleting': 'Verileriniz temizleniyor, lütfen bekleyin...',
  },
  en: {
    // General
    'app.title': 'ArchaeoHub',
    'app.loading': 'Loading...',
    'app.error': 'Error',
    'app.save': 'Save',
    'app.cancel': 'Cancel',
    'app.delete': 'Delete',
    'app.edit': 'Edit',
    'app.close': 'Close',
    'app.search': 'Search...',
    'app.date': 'Date',
    'app.time': 'Time',
    
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.assets': 'Assets',
    'nav.reconstruct': 'Reconstruct',
    'nav.logout': 'Logout',
    'nav.register': 'Register',

    // Login View
    'login.title': 'Welcome Back',
    'login.subtitle': 'Manage your excavations with ArchaeoHub',
    'login.email': 'Email Address',
    'login.password': 'Password',
    'login.button': 'Sign In',
    'login.error': 'Login failed. Please check your credentials.',
    'login.name': 'Full Name',
    'login.passwordHint': 'Min 6 characters',
    'login.confirmPassword': 'Confirm Password',
    'login.register': 'Create Account',

    // Dashboard View
    'dashboard.title': 'Active Excavation Sites',
    'dashboard.addSite': 'Add New Site',
    'dashboard.deleteConfirm': 'Are you sure you want to delete this site? This action cannot be undone.',
    'dashboard.noSites': 'No excavation sites found.',
    'dashboard.createSite': 'Create Site',
    'dashboard.siteName': 'Site Name',
    'dashboard.siteDesc': 'Description',
    'dashboard.siteLocation': 'Location',
    'dashboard.siteDirector': 'Site Director',
    'dashboard.sitePeriod': 'Period',
    'dashboard.siteStatus': 'Status',
    'dashboard.statusActive': 'Active',
    'dashboard.statusPaused': 'Paused',
    'dashboard.statusCompleted': 'Completed',
    
    // Site Detail View
    'site.tabDetails': 'Details',
    'site.tabAssets': 'Library',
    'site.tabLogbook': 'Logbook',
    'site.tabReconstruct': 'Assembly',
    'site.edit': 'Edit Site',
    'site.director': 'Director',
    'site.period': 'Period',
    'site.location': 'Location',
    'site.status': 'Status',
    'site.members': 'Authorized Members',
    'site.membersLabel': 'Authorized Members (Email)',
    'site.addMember': 'Add Member',
    'site.enterEmail': 'Member email address...',
    'site.recentActivity': 'Recent Activity',
    'site.noActivity': 'No activity yet. Add a logbook entry or upload a 3D asset to get started.',
    'site.analyses': 'Analyses',
    'site.analysesSub': 'Site statistics & reports',
    'site.comingSoon': 'Coming Soon',
    
    // Assets View
    'assets.title': 'Library',
    'assets.upload': 'Upload Artifact/Model',
    'assets.createFolder': 'Create Folder',
    'assets.guide': '3DF Zephyr Guide',
    'assets.empty': 'This folder is empty.',
    'assets.dragDrop': 'Drag and drop files here or',
    'assets.browse': 'browse from computer',
    'assets.supported': 'Supported formats: OBJ, STL, PLY, GLB and Images (JPG, PNG). You can drag and drop folder structures.',
    'assets.takePhoto': 'Take Photo',
    'assets.uploading': 'Uploading...',
    'assets.folderName': 'Folder Name',
    'assets.viewerTitle': '3D Viewer',
    'assets.pdfBtn': '📄 View Assembly Diagram',
    'assets.rotation': '⟲ Rotate',
    'assets.resetView': 'Reset View',
    'assets.moveAsset': 'Move Asset',
    'assets.targetFolder': 'Target Folder',
    'assets.rootDir': '(Root Directory)',
    'assets.move': 'Move',
    'assets.folderCount': 'folder(s)',
    'assets.fileCount': 'file(s)',

    // Logbook View
    'logbook.title': 'Logbook & Inventory',
    'logbook.addEntry': 'Add New Entry',
    'logbook.empty': 'No entries found yet.',
    'logbook.type': 'Entry Type',
    'logbook.typeFind': 'Artifact Find',
    'logbook.typeTrench': 'Trench Log',
    'logbook.typeNote': 'General Note',
    'logbook.entryTitle': 'Title',
    'logbook.content': 'Content',
    'logbook.images': 'Images',
    'logbook.tags': 'Tags (Comma separated)',
    'logbook.artifactID': 'Artifact ID',
    'logbook.material': 'Material',
    'logbook.dimensions': 'Dimensions',
    'logbook.location': 'Find Location',
    
    // Reconstruct View
    'recon.title': 'Assembly Desk',
    'recon.subtitle': 'Assemble 3D parts by dragging and dropping',
    'recon.selectParts': '1. Select Parts from Library',
    'recon.library': 'Library',
    'recon.emptyLib': 'No 3D models in the library.',
    'recon.addToDesk': 'Add to Desk',
    'recon.desk': '2. Workspace',
    'recon.emptyDesk': 'Desk is empty. Add parts from the library.',
    'recon.clearDesk': 'Clear Desk',
    'recon.preview': 'Preview (Assemble)',
    'recon.downloadPDF': '📄 Download Assembly Diagram',
    'recon.saveToLib': '💾 Save to Library',
    'recon.controls': 'Controls: Left Click + Drag = Rotate | Right Click + Drag = Pan | Scroll = Zoom',
    'recon.loading1': 'Preparing files for upload...',
    'recon.loading2': 'Sending data to assembly server...',
    'recon.loading3': 'Processing geometry (this may take a moment)...',
    'recon.loading4': 'Loading result...',
    'recon.done': 'Assembly Complete!',
    'recon.download': 'Download Model',
    'recon.processingTitle': 'Processing...',
    'recon.processingDesc': 'Analyzing geometry and texture patterns',
    'recon.packagingLib': 'Packaging (Model + PDF)...',
    'recon.uploadingModel': 'Uploading (Model)...',
    'recon.capturingPhotos': 'Saving photos...',
    'recon.uploadingPDF': 'Uploading (PDF)...',
    'recon.addedToLib': 'Added to Library',
    'recon.added': '✅ Added',
    'recon.mobileWarning': 'The assembly desk may not perform optimally on mobile devices. For the best experience, we recommend using the desktop version.',
    'recon.tryAnyway': 'Try anyway',
    'recon.photogrammetryTitle': 'Generate 3D Model',
    'recon.photogrammetryConfirm': 'A 3D model will be generated using the {count} photos in the "{name}" folder. Processing cost: {credits} credit(s).',
    'recon.photogrammetryDesc': 'This process will be performed automatically on our cloud servers. Credits will be deducted when the job starts, and a .glb or .obj file will be added to your library upon completion.',
    'recon.photogrammetryQueued': 'The 3D model generation job has been queued. we will notify you when it is complete.',
    'recon.photogrammetryNoPhotos': 'No photos in supported format found in this folder.',
    'recon.photogrammetryMinPhotos': 'At least 10 photos are required for this process.',

    // Credits
    'credits.creditLabel': 'Credit',
    'credits.balance': 'Credit Balance',
    'credits.currentBalance': 'Current Balance',
    'credits.buy': 'Buy Credits',
    'credits.assemblyPrice': 'Each assembly costs 1 credit ($1).',
    'credits.webNotice': 'Purchase credits in the ArchaeoHub mobile app.',
    'credits.purchaseSuccess': 'Credits added successfully',
    'credits.purchaseFailed': 'Purchase failed',
    'credits.purchaseCancelled': 'Purchase cancelled',
    'credits.insufficient': 'Insufficient credits. You need at least 1 credit to run an assembly.',
    'credits.history': 'Transaction History',
    'credits.noHistory': 'No transactions yet.',

    // Landing Page
    'landing.heroTag': '🏺 Digital Archaeology Platform',
    'landing.heroTitle': 'The Modern Way to Manage Excavations',
    'landing.heroSub': 'ArchaeoHub brings excavation sites, 3D artifact scanning, digital logbooks, and intelligent fragment reconstruction into one unified platform.',
    'landing.startFree': '🚀 Start for Free',
    'landing.explore': 'Explore Features',
    'landing.stats3D': '3D Artifact Scanning',
    'landing.statsAI': 'AI Fragment Assembly',
    'landing.statsLang': '2 Languages',
    'landing.statsSites': '∞ Sites & Team Members',
    'landing.featuresTitle': 'Everything your team needs',
    'landing.featuresSub': 'From the field to the lab — ArchaeoHub covers the entire archaeological workflow.',
    'landing.workflowTitle': 'From dig to documentation',
    'landing.workflowSub': 'A simple four-step process that fits naturally into your excavation workflow.',
    'landing.pricingTitle': 'Simple pay-as-you-go',
    'landing.pricingSub': 'ArchaeoHub is free to use. You only pay when you run an AI fragment reconstruction.',
    'landing.pricingNote': 'Credits are purchased securely through <strong>Google Play</strong> in the Android app. Credits never expire. All other features are completely <strong>free</strong>.',
    'landing.pricingUserNote': '1 credit = 1 USD (price might change depending on location and taxes are not included)',
    'landing.ctaTitle': 'Start documenting your excavation today',
    'landing.ctaSub': 'Free to sign up. No credit card required. Works on desktop and mobile.',
    'landing.footerCopy': '© 2026 ArchaeoHub. All rights reserved.',
    'landing.privacy': 'Privacy Policy',
    'landing.contactEmail': 'gulerege.tr@gmail.com',
    'landing.feature1Title': 'Management',
    'landing.feature1Desc': 'Create and manage unlimited excavation sites with team-based permissions.',
    'landing.feature2Desc': 'Upload and view 3D scans. Organize artifacts into folders effortlessly.',
    'landing.feature3Desc': 'Intelligently assemble fragments using our automated reconstruction server.',
    'landing.feature4Title': 'PDF Guides',
    'landing.feature4Desc': 'Generate bilingual assembly diagrams for every reconstruction automatically.',

    // Account Deletion
    'deleteAccount.title': 'Delete Account',
    'deleteAccount.warning': 'WARNING: This action cannot be undone.',
    'deleteAccount.explanation': 'When you delete your account; all your excavation sites, uploaded 3D models, digital logs, and active credits will be permanently removed.',
    'deleteAccount.confirmLabel': 'Type "DELETE" to confirm:',
    'deleteAccount.button': 'Permanently Delete My Account',
    'deleteAccount.reauthRequired': 'For security reasons, you must re-authenticate to perform this action.',
    'deleteAccount.success': 'Your account and all associated data have been deleted.',
    'deleteAccount.error': 'An error occurred while deleting your account.',
    'deleteAccount.deleting': 'Cleaning up your data, please wait...',
  }
};

// Default to Turkish, read from localStorage if available
let currentLang = localStorage.getItem('archaeohub_lang') || 'tr';

export function setLanguage(lang) {
  if (translations[lang]) {
    currentLang = lang;
    localStorage.setItem('archaeohub_lang', lang);
    // Dispatch a custom event so the app can re-render
    window.dispatchEvent(new CustomEvent('languageChanged', { detail: { lang } }));
  }
}

export function getLanguage() {
  return currentLang;
}

export function t(key) {
  const dict = translations[currentLang];
  if (dict && dict[key]) {
    return dict[key];
  }
  // Fallback to Turkish then just the key
  if (translations['tr'] && translations['tr'][key]) {
    return translations['tr'][key];
  }
  return key; // return key if not found
}
